/**
 * @see https://docs.mul-pay.jp/paypal/overview
 * PayPal上での認証、支払操作完了後の決済処理後、決済失敗かつエラー詳細コードが
 * P01020006、P01020008 、P01020011の取引に対して操作が行われる場合があります。PayPal側で一旦保留とされ審査が行われます。
 * 支払い審査は通常24時間程度で完了し、その結果問題なければ決済成功、問題があると判断されれば決済失敗となります。
 */
const PAYPAL_PENDING_ERROR_CODES = ["P01020006", "P01020008", "P01020011"];

export const isPayPalPendingError = (errorInfo: string | null): boolean => {
  if (!errorInfo) {
    return false;
  }

  return PAYPAL_PENDING_ERROR_CODES.includes(errorInfo);
};
